import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';
import {
    Typography, TableCell, IconButton, TableRow, Grid, RadioGroup,
    FormControlLabel, Radio, Switch, Button, FormControl, TextField, useTheme, useMediaQuery
} from '@material-ui/core';

import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import InfoIcon from '@material-ui/icons/Info'
import { genfunction } from 'helpers'
import { NumberInput, FormattedInputs } from 'components'
import { Height } from '@material-ui/icons';

const { Currency } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    amountBtn: {
        margin: 3
    },
    img: {
        width: "100%",
        //Height: 200,
        objectFit: "cover",
        objectPosition: "bottom"
    }
}));

const StyledToggleButtonGroup = withStyles((theme) => ({
    grouped: {
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(1),
        display: "unset",
        minWidth: 60,
        border: '1px solid !important',
        '&:not(:first-child)': {
            borderRadius: theme.shape.borderRadius,
        },
        '&:first-child': {
            borderRadius: theme.shape.borderRadius,
        },
    }

}))(ToggleButtonGroup);

const DonationProduct = props => {
    const { Product, onChangeAmount } = props;
    const classes = useStyles();

    const cartDonationProducts = useSelector(state => state.reducerShopCart.donationProducts);

    let [selectedToogleButton, setSelectedToogleButton] = React.useState(null);
    let [otherAmount, setOtherAmount] = React.useState(null);
    let [validationInfo, setValidationInfo] = React.useState("");

    let hasImage = Product.ProductImageURL && Product.ProductImageURL != "";

    useEffect(() => {
        if (cartDonationProducts && cartDonationProducts.length > 0) {
            let item = cartDonationProducts.find(x => x.ProductID == Product.ProductID)
            if (item) {
                if (item.DisplayAmount == "other")
                    setOtherAmount(item.Amount);

                setSelectedToogleButton(item.DisplayAmount);
            }
        }
    }, [cartDonationProducts])

    const onChangeToogleButtonHandler = (event, newValue) => {
        setSelectedToogleButton(newValue);
        if (newValue)
            onChangeAmount(getNewProductObj(Product, newValue.toString(), newValue == "other" ? 0 : parseFloat(newValue)))
        else
            onChangeAmount(getNewProductObj(Product, "", 0))

        if (newValue != "other")
            setOtherAmount(null);
    };

    const getNewProductObj = (product, displayAmount, amount) => {
        let prod = {
            ProductID: product.ProductID,
            ProductName: product.ProductName,
            DisplayArea: product.DisplayArea,
            DisplayAmount: displayAmount,
            Amount: amount,
            UseAlternateMerchantOnline: product.UseAlternateMerchantOnline
        }
        return prod;
    }

    const onValidationChangeOtherAmount = (info) => {
        setValidationInfo(info);
    }

    const onChangeOtherAmount = (event) => {
        setOtherAmount(event.target.value);
        onChangeAmount(getNewProductObj(Product, "other", parseFloat(event.target.value)))
    }

    const getDisplayAmountButtons = (product) => {

        return <StyledToggleButtonGroup
            value={selectedToogleButton}
            exclusive
            onChange={onChangeToogleButtonHandler}
            aria-label="text ToogleButton"
            size='small'
            style={{ display: "unset" }}

        >
            {product.DisplayAmounts?.sort((a, b) => a.SortOrder - b.SortOrder).map(amount => {
                return <ToggleButton key={Product.ProductID + "_" + amount.Amount} value={amount.Amount.toString()} aria-label="left aligned">
                    {Currency + amount.Amount}
                </ToggleButton>
            })}
            {product.OtherValue && product.OtherValue.length > 0 ?
                <ToggleButton key={Product.ProductID + "_other"} value="other" aria-label="left aligned">
                    Other
                </ToggleButton> : ""}
            {selectedToogleButton == "other" ?
                <FormattedInputs
                    donaValue={otherAmount}
                    minValue={Product.OtherValue[0].MinAmount}
                    maxValue={Product.OtherValue[0].MaxAmount}
                    productName={Product.ProductName}
                    handleOtherPrice={onChangeOtherAmount}
                    Validated={onValidationChangeOtherAmount}
                ></FormattedInputs> : ""}

        </StyledToggleButtonGroup>
    }

    return (
        <Grid item container spacing={2}>
            <Grid item xs={12}>
                <Typography variant='h4'>{Product.ProductName}</Typography>
            </Grid>
            <Grid container item spacing={2}>
                {hasImage ?
                    <Grid item xs={4}>
                        <img src={genfunction.replaceEscapeCharacters(Product.ProductImageURL)} className={classes.img} />
                    </Grid> : ""}
                <Grid item xs={hasImage ? 8 : 12}>
                    <Grid item xs={12}>
                        <Typography variant='subtitle1'>{Product.ProductDescription}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        {getDisplayAmountButtons(Product)}</Grid>
                    <Grid item xs={12}>
                        {validationInfo != "" ?
                            <Typography variant='caption' color='error'>{validationInfo}</Typography> : ""}
                    </Grid>
                </Grid>
            </Grid>

        </Grid>
    );
};

export default DonationProduct;